<!-- 发票列表 -->
<template>
    <div class='page_content'>
        <processAuditAction ref="processAuditAction"></processAuditAction>

        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>

                </vSearch>
            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" ref="mainTable" :show-summary="true" :summary-method="getSummaries" @selection-change="handleSelectionChange" :height="tableHeight"
                      :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
                <el-table-column type="selection" width="40"></el-table-column>
                <!-- 主表单 -->
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField"
                                 :label="tableValye.showField" show-overflow-tooltip :min-width="tableValye.fieldWeight">
                    <template slot-scope="scope">
                        <!-- 开票日期 -->
                        <template v-if="tableValye.fieldType == 'date'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                        </template>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                scope.row[tableValye.entityField] }}</a>
                        </span>
                        <el-link v-else-if="tableValye.entityField == 'uploadVoList' && scope.row[tableValye.entityField].length > 0" @click="lookFile(scope.row)">
                            查看
                        </el-link>
                        <span v-else-if="tableValye.entityField == 'uploadVoList' && scope.row[tableValye.entityField].length < 1">

                        </span>
                        <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                            {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                        <span v-else>{{ scope.row[tableValye.entityField] }}</span>

                    </template>
                </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog title="确定将选中审核吗?" :visible.sync="taskVisible" width="30%">
            <span slot="footer" class="dialog-footer">
                <el-button @click="taskVisible = false">取 消</el-button>
                <el-button @click="batchAudit(-1)">拒 绝</el-button>
                <el-button type="primary" @click="batchAudit(2)">通 过</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="smId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <uploadFile ref="uploadFile" v-if="showStatusFile"></uploadFile>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"
import uploadFile from '@/components/uploadFile.vue'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        uploadFile
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                coId: '', // 供货商D
                coName: '', // 供货商名称
                page: 1,
                rows: 30,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
                ftState: ''
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },
            buttonList: [],

            pageShowData: [],
            formDataList: null,
            selectedDataIndex: 0,
            multipleSelection: [],
            userOneList: [],
            seTitle: "", //检索
            DialogVisible: false,
            seWidth: '0',
            seId: 0,
            smId: 0,
            sField: '',
            showStatusFile: false,
            taskVisible: false,
            totalField: ['invoicingMoney']
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        'getRequestData.coName': {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.getRequestData.coId = ''
                }
            },
            deep: true,
        }
    },
    created() {
        this.getPageInfo()
    },
    //方法集合
    methods: {
        // 自定义合计字段
        getSummaries(param) {
            const {
                columns,
                data
            } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (this.totalField.includes(column.property)) {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return this.toDecimal(prev + curr);
                            } else {
                                return this.toDecimal(prev)
                            }
                        }, 0);
                        sums[index] = this.$common.getDecimalInfo(3, sums[index])
                        // sums[index] = sums[index].toFixed(2)
                        // sums[index] += ' 元';
                    } else {
                        sums[index] = 'N/A';
                    }
                } else {
                    sums[index] = ''
                }
            });

            return sums;
        },
        toDecimal(x) {
            var f = parseFloat(x);
            if (isNaN(f)) {
                return;
            }
            f = Math.round(x * 100) / 100;
            return f;
        },
        // 勾选
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        lookFile(row) {
            this.showStatusFile = true
            this.$nextTick(() => {
                this.$refs.uploadFile.openBox(row.uploadVoList, 1)
            })
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            // console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },

        isShowData(name, value) {
            switch (name) {
                case 'customerList':
                    var dataInfo = sessionStorage.getItem('selectCustomerData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.getRequestData.smId = dataInfo.smId
                        this.getRequestData.smName = dataInfo.smName
                    }

                    break;

                default:
                    this.getRequestData[name] = value

            }
        },
        //获取表头信息
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            })
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
                this.formDataList = this.pageShowData.jurFormVoList
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30, false)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30, false)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                this.getButtonList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType);
            switch (actionData.actionType) {
                case 1:
                    var dataInfo = this.returnData.list[this.selectedDataIndex]
                    if (!dataInfo) {
                        this.$message({
                            message: '请先选择您要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    // this.$refs["purchaseInvoiceActive"].openBox(1, this.formDataList, dataInfo);
                    break;
                case 4:
                    this.taskAudit()
                    break;
                case 5:
                    if (this.returnData.list.length < 1) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    if (this.multipleSelection.length < 1) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.$refs["processAuditAction"].openBox(1, this.multipleSelection[0].ftId);
                    break;
                case 6:
                    // if (this.returnData.list.length < 1) {
                    //     this.$message({
                    //         message: "暂无数据",
                    //         type: "error",
                    //     });
                    //     return false;
                    // }
                    // if (this.multipleSelection.length != 1) {
                    //     this.$message({
                    //         message: "请先选中一条要操作的数据",
                    //         type: "error",
                    //     });
                    //     return false;
                    // }
                    this.$prompt('请输入发票抵用金额', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputValidator: value => {
                            if (value > this.multipleSelection[0].invoicingMoney) {
                                return false
                            } else if (value > this.multipleSelection[0].invoicingMoney && value > 0) {
                                return true
                            }
                        },
                        inputErrorMessage: '抵用金额不可大于发票金额'
                    }).then(({ value }) => {
                        this.$http.updateoffsetMoney({
                            offsetMoney: value,
                            ftId: this.multipleSelection[0].ftId
                        }).then(res => {
                            if (res.status == 200) {
                                this.$message.success(res.message)
                                this.getDataList()
                            }
                        })
                    }).catch(() => {
                    });
                    break;
                case 8:
                    this.showPrintPlan()
                    break;
            }
        },
        taskAudit() {
            if (this.returnData.list.length < 1) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }
            if (this.multipleSelection.length < 1) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.taskVisible = true
        },
        async batchAudit(state) {
            let ids = []
            this.multipleSelection.forEach(v => {
                ids.push(v.ftId)
            })
            var delData = {
                ids: ids,
                state,
            };
            let responseData = await this.$http.feeticketApproval(delData);
            if (responseData.status == 200) {
                this.$message({
                    type: "success",
                    message: "操作成功",
                });
                this.taskVisible = false
                this.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        showPrintPlan() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                var info = this.returnData.list[this.selectedDataIndex]
                this.$refs.printPlan.openDia(info.woamId)
            } else {
                return
            }
        },

        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.feeticketTask(this.getRequestData)
            // console.log(responseData);
            if (responseData && responseData.status == 200) {
                let resData = JSON.parse(JSON.stringify(responseData))
                this.returnData.list = resData.result.list
                this.returnData.pages = resData.result.pages
                this.returnData.total = resData.result.total
                this.returnData.pageNum = resData.result.pageNum
                this.selectedDataIndex = 0
                this.$nextTick(() => [
                    this.$refs.mainTable.doLayout()
                ])
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight(); this.$store.state.tableNum }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped></style>